// extracted by mini-css-extract-plugin
export var button = "_9w-0";
export var icon = "_9w-1";